import "../../Label.css";
import React__default from "react";
const base = "Label_base_695b4";
const alignRight = "Label_alignRight_695b4";
const textOnly = "Label_textOnly_695b4";
const css = {
  base,
  alignRight,
  textOnly
};
const LabelTypes = {
  TextOnly: "textOnly"
};
const Label = ({ className, children, type, ...props }) => {
  const classes = [css.base];
  if (type)
    classes.push(css[type]);
  if (className)
    classes.push(className);
  return React__default.createElement("div", { className: classes.join(" "), ...props }, children);
};
export {
  LabelTypes,
  Label as default
};
